import React from 'react';
import Icon from '../../../components/AppIcon';
import Image from '../../../components/AppImage';
import Button from '../../../components/ui/Button';

const MonthlyChampionsSection = () => {
  const champions = [
    {
      id: 1,
      name: "Rajesh Kumar",
      city: "Mumbai",
      state: "Maharashtra",
      winAmount: 2500000,
      game: "Royal Roulette",
      photo: "https://images.unsplash.com/photo-1507003211169-0a1dd7228f2d?w=400&h=400&fit=crop&crop=face",
      quote: "The WhatsApp support team guided me through every step. Best gaming platform in India!",
      date: "15th August 2025",
      badge: "Biggest Win"
    },
    {
      id: 2,
      name: "Priya Sharma",
      city: "Delhi",
      state: "Delhi",
      winAmount: 1800000,
      game: "Teen Patti Gold",
      photo: "https://images.unsplash.com/photo-1494790108755-2616b612b786?w=400&h=400&fit=crop&crop=face",
      quote: "Instant payout within 15 minutes! Nitin keeps their promises. Highly recommended!",
      date: "12th August 2025",
      badge: "Fastest Payout"
    },
    {
      id: 3,
      name: "Amit Patel",
      city: "Ahmedabad",
      state: "Gujarat",
      winAmount: 1200000,
      game: "Andar Bahar Pro",
      photo: "https://images.unsplash.com/photo-1472099645785-5658abf4ff4e?w=400&h=400&fit=crop&crop=face",
      quote: "Started with ₹5000, now I'm a champion! The customer service via WhatsApp is exceptional.",
      date: "10th August 2025",
      badge: "Rising Star"
    }
  ];

  const handleWhatsAppContact = () => {
    const message = "Hi! I saw the monthly champions and I'm interested in starting my winning journey with Nitin Online Hub. Can you guide me?";
    window.open(`https://wa.me/+917704070169?text=${encodeURIComponent(message)}`, '_blank');
  };

  const getBadgeColor = (badge) => {
    switch (badge) {
      case 'Biggest Win': return 'bg-gradient-royal';
      case 'Fastest Payout': return 'bg-success';
      case 'Rising Star': return 'bg-accent';
      default: return 'bg-primary';
    }
  };

  return (
    <section className="py-16 bg-surface-secondary">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        {/* Section Header */}
        <div className="text-center mb-12">
          <div className="flex items-center justify-center space-x-2 mb-4">
            <Icon name="Crown" size={32} color="var(--color-primary)" />
            <h2 className="text-3xl md:text-4xl font-heading font-bold text-gradient-royal">
              This Month's Champions
            </h2>
          </div>
          <p className="text-lg text-text-secondary max-w-2xl mx-auto">
            Meet our August 2025 winners who turned their dreams into reality with Nitin Online Hub and Nitin Online Book
          </p>
        </div>

        {/* Champions Grid */}
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8 mb-12">
          {champions?.map((champion) => (
            <div
              key={champion?.id}
              className="bg-card rounded-card shadow-subtle hover:shadow-royal transition-royal overflow-hidden group"
            >
              {/* Champion Photo */}
              <div className="relative">
                <Image
                  src={champion?.photo}
                  alt={`${champion?.name} - Monthly Champion`}
                  className="w-full h-64 object-cover"
                />
                
                {/* Badge Overlay */}
                <div className={`absolute top-4 left-4 ${getBadgeColor(champion?.badge)} text-white px-3 py-1 rounded-full text-sm font-bold flex items-center space-x-1`}>
                  <Icon name="Award" size={16} />
                  <span>{champion?.badge}</span>
                </div>

                {/* Win Amount Overlay */}
                <div className="absolute bottom-4 left-4 right-4 bg-black/70 backdrop-blur-sm text-white p-3 rounded-card">
                  <div className="text-2xl font-heading font-bold text-yellow-400">
                    ₹{champion?.winAmount?.toLocaleString('en-IN')}
                  </div>
                  <p className="text-sm opacity-90">Won on {champion?.date}</p>
                </div>
              </div>

              {/* Champion Info */}
              <div className="p-6">
                <div className="flex items-center space-x-3 mb-4">
                  <div className="w-12 h-12 bg-gradient-royal rounded-full flex items-center justify-center">
                    <Icon name="Trophy" size={20} color="white" />
                  </div>
                  <div>
                    <h3 className="font-heading font-semibold text-text-primary">{champion?.name}</h3>
                    <p className="text-sm text-text-secondary">{champion?.city}, {champion?.state}</p>
                  </div>
                </div>

                <div className="mb-4">
                  <p className="text-sm text-text-secondary mb-2">Winning Game:</p>
                  <p className="font-medium text-primary">{champion?.game}</p>
                </div>

                <blockquote className="text-text-primary italic mb-4">
                  "{champion?.quote}"
                </blockquote>

                <div className="flex items-center space-x-2 text-sm text-text-secondary">
                  <Icon name="Calendar" size={14} />
                  <span>{champion?.date}</span>
                  <Icon name="MapPin" size={14} className="ml-2" />
                  <span>{champion?.city}</span>
                </div>
              </div>
            </div>
          ))}
        </div>

        {/* CTA Section */}
        <div className="text-center bg-gradient-royal rounded-card p-8 text-white">
          <div className="max-w-2xl mx-auto">
            <h3 className="text-2xl font-heading font-bold mb-4">
              Ready to Become Our Next Champion?
            </h3>
            <p className="text-lg opacity-90 mb-6">
              Join thousands of winners who chose Nitin Online Hub for their gaming success
            </p>
            
            <div className="flex flex-col sm:flex-row gap-4 justify-center">
              <Button
                variant="secondary"
                size="lg"
                onClick={handleWhatsAppContact}
                iconName="MessageCircle"
                iconPosition="left"
                className="bg-white text-primary hover:bg-gray-100"
              >
                Start Your Winning Journey
              </Button>
              <Button
                variant="outline"
                size="lg"
                onClick={() => window.open('https://wa.me/917704070169', '_blank')}
                iconName="Phone"
                iconPosition="left"
                className="border-white text-white hover:bg-white/10"
              >
                Speak to Expert
              </Button>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default MonthlyChampionsSection;